<template>
  <v-main>
    <Card style="margin-bottom: 24px" :title="title">
      <ConfirmationForm v-if="stage==='confirmation'" module="login" />
      <PasswordForm v-else-if="stage==='password'" module="login" />
      <InitForm v-else module="login" />
    </Card>
    <div class="font--action-small font--color_light text-center">
      <span class="mr-1">Уже Зарегистрированы?</span>
      <router-link class="text-link text-decoration-none" to="/account/login">Войти</router-link>
    </div>
  </v-main>
</template>

<script>
import Card from "@/components/login/Card";
import InitForm from "@/components/login/InitForm";
import ConfirmationForm from "@/components/login/ConfirmationForm";
import PasswordForm from "@/components/login/PasswordForm";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      interceptor: null,
    };
  },
  components: {
    Card,
    InitForm,
    ConfirmationForm,
    PasswordForm,
  },
  computed: {
    ...mapGetters("login", ["stage"]),
    title() {
      return this.stage === "password"
        ? "Смена пароля"
        : "Восстановление пароля";
    },
  },
  methods: {
    ...mapActions("common", ["clearErrdesc"]),
  },
  destroyed() {
    this.clearErrdesc();
  },
};
</script>
